var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Uploads-Flow-+-New-Doc-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-449.000000, -1010.000000)",
    fill: "#3F3F3F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464,1024 L457,1024 L457,1022 L464,1022 L464,1024 L464,1024 Z M467,1020 L457,1020 L457,1018 L467,1018 L467,1020 L467,1020 Z M467,1016 L457,1016 L457,1014 L467,1014 L467,1016 L467,1016 Z M451,1014 L451,1030 L467,1030 L467,1032 L451,1032 C449.895431,1032 449,1031.10457 449,1030 L449,1014 L451,1014 L451,1014 Z M469,1010 C470.104569,1010 471,1010.89543 471,1012 L471,1026 C471,1027.11 470.11,1028 469,1028 L455,1028 C453.895431,1028 453,1027.10457 453,1026 L453,1012 C453,1010.89 453.89,1010 455,1010 L469,1010 L469,1010 Z M455,1012 L455,1026 L469,1026 L469,1012 L455,1012 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.532fb962e421a413d6d26cd1ce865e12.svg";
export { ForwardRef as ReactComponent };